import logoPrimary from '@assets/images/common/brand/logo-primary.svg';
import { handleApiResponse } from '@src/api/apiClient/axiosClient';
import { resetPasswordApiClient } from '@src/api/tenant/auth/resetPasswordApiClient';
import { useToast } from '@src/features/toast/context/toastContext';
import TOAST_MESSAGE from '@src/modules/constants/toastMessage';
import Button from '@src/ui/elements/button/Button';
import { useEffect, useState } from 'react';

interface SendResetPasswordEmailFormErrors {
  email?: string[];
}

function ResetPasswordForm() {
  const [email, setEmail] = useState('');
  const [errors, setErrors] = useState<SendResetPasswordEmailFormErrors>({});
  const [isPasswordReset, setIsPasswordReset] = useState(false);
  const [isSubmitButtonPressed, setIsSubmitButtonPressed] = useState(false);
  const toast = useToast();
  const RESUBMIT_WAIT_TIME = 60000;

  const handleSubmit = async () => {
    if (isSubmitButtonPressed) {
      return;
    }
    setIsSubmitButtonPressed(true);
    const response = await resetPasswordApiClient.reset({ email: email });
    handleApiResponse(
      response,
      () => {
        toast(TOAST_MESSAGE.SEND);
        setIsPasswordReset(true);
        setErrors({});
      },
      (errors) => {
        console.error('Failed to reset password', errors);
        setIsSubmitButtonPressed(false);
        setErrors(errors);
      },
    );
  };

  useEffect(() => {
    if (isPasswordReset) {
      setTimeout(() => {
        setIsPasswordReset(false);
        setIsSubmitButtonPressed(false);
      }, RESUBMIT_WAIT_TIME);
    }
  }, [isPasswordReset]);

  return (
    <div className='flex flex-col gap-8'>
      <div className='grid place-items-center'>
        <img
          alt={import.meta.env.VITE_APP_NAME}
          className='max-h-[72px] w-[400px] object-contain'
          src={logoPrimary}
        />
      </div>
      <p className='text-center'>
        登録されたメールアドレスを入力し、
        <br />
        送信ボタンを押してください。
      </p>
      <form
        className='flex flex-col gap-6'
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit();
        }}
      >
        <div className='flex flex-col gap-[26px]'>
          <div className='flex flex-col gap-4'>
            <div className='flex flex-col gap-[6px]'>
              <label
                className='label-login'
                htmlFor='email'
              >
                メールアドレス
              </label>
              <input
                id='email'
                type='email'
                className={`input-login ${errors.email ? 'error-input' : ''}`}
                placeholder='メールアドレス'
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              {errors.email?.map((error, index) => (
                <p
                  key={index}
                  className='error-message'
                >
                  {error}
                </p>
              ))}
            </div>
          </div>
          <Button
            fullRounded
            fullWidth
            disabled={isSubmitButtonPressed}
            onClick={handleSubmit}
          >
            送信
          </Button>
          {isPasswordReset && <p className='text-center'>60秒後に再送信できます</p>}
        </div>
      </form>
    </div>
  );
}

export default ResetPasswordForm;
